// The client-backed pipeline: search and filters, then sort.

import { productLocale } from '../format'
import { matchesFilters } from './filters'
import { matchesSearch } from './search'
import { sortRows } from './sort'

/**
 * @param {object[]} rows the complete client set
 * @param {object[]} columns
 * @param {{search: string, filters: object, sort: object}} query
 * @param {string} [locale]
 * @param {{hidden?: string[]}} [view] hidden columns take no part in search or filters
 */
export const runQuery = (
  rows,
  columns,
  { search, filters, sort },
  locale,
  { hidden = [] } = {}
) => {
  const loc = productLocale(locale)
  const matching = rows.filter(
    row =>
      matchesSearch(row, columns, search, loc, hidden) &&
      matchesFilters(row, columns, filters, hidden)
  )
  return sortRows(matching, sort, columns, loc)
}
